var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex } from 'shared/components';
import { usePowerPanelContext } from '../contexts';
import { useDismissOnNav } from 'shared/hooks';
import { PowerPanel } from './powerPanel';
import { useMemo } from 'react';
export var PowerPanelWrapper = function (_a) {
    var children = _a.children;
    var _b = usePowerPanelContext(), disclosure = _b.disclosure, dismissOnNav = _b.dismissOnNav;
    var dismissOnNavFilter = useMemo(function () { return (typeof dismissOnNav === 'function' ? dismissOnNav : function () { return true; }); }, [dismissOnNav]);
    useDismissOnNav(disclosure.onClose, dismissOnNavFilter, !!dismissOnNav);
    return (_jsxs(Flex, { children: [_jsx(Box, __assign({ flexGrow: 1 }, { children: children })), disclosure.isOpen && _jsx(PowerPanel, {})] }));
};
